import React from 'react';
import PropTypes from 'prop-types';

import { components } from 'react-select';

const Option = ({ children, ...rest }) => {
  // Multi-line value or single line value
  const value = rest.value ? (rest.value.value || rest.value).split(' ').join('-') : '';
  return (
    <components.Option {...rest}>
      <div
        className='selectOption prl4-sm pt4-sm pb5-sm'
        data-desc={`select__${rest.selectProps.input.name}_option_${value}`}
      >
        {children}
      </div>
    </components.Option>
  );
};

Option.defaultProps = {
  children: null
};

Option.propTypes = {
  children: PropTypes.any,
  selectProps: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

export default Option;
